module.exports = {
	"articleTitle1": "Best Off-Campus Bar: Mash ",
	"catImage": "yellowstar.png",
	"totalCats": 1,
	"name": "Mash",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/arts/4best-main-street-area-bar-mash16",
	"articleSnippet1": "Mar 30, 2017 ... Despite the rustic appeal of its decor, the speakeasy nature of its booths and bar, \nthe chalk is what gives Mash a sense of identity amongst the ...",
	"articleSnippet2": "Apr 10, 2015 ... Its basement atmosphere is what makes Mash so special. The bar is dim, but not \ndark; the wood detailing gives it a rustic feel and the walls are ...",
	"foodRecommendations": [],
	"articleTitle2": "Best Main Street Area Bar: Mash",
	"address": "211 E Washington St, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/170412/ram.BestofAnnArbor.MASH_.4.9.15072.jpg?itok=T3rAfAez",
			"author": "File Photo",
			"caption": ""
		}
	],
	"position": {
		"lat": 42.280554,
		"lng": -83.746749
	},
	"totalMisc": 1,
	"categories": {
		"nightlife": 1,
		"bestofaa": 1,
		"location": 1,
		"entertainment": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/mash.json
// module id = 915
// module chunks = 0